module.exports = __webpack_public_path__ + "img/dianhua@3x.d42f6a1f.png";